export const CURRENT_CLIENT_INTERVIEW_DETAILS = 'currentClientInterviewDetails';
